export default __webpack_public_path__ + "static/media/phone2.d28da493.svg";